import { Grid, makeStyles } from '@material-ui/core'

import OfflineButton from 'src/components/sections/Navbar/GridNavBar/OfflineButton'
import HelpButton from 'src/components/sections/Navbar/HelpButton'
import LanguageButton from 'src/components/sections/Navbar/LanguageButton'
import SettingsButton from 'src/components/sections/Navbar/SettingsButton'

const useStyles = makeStyles((theme) => ({
	menuIcons: {
		display: 'flex',
		marginLeft: 'auto',
		justifyContent: 'end',
	},
}))

function GridNavbarActions({
	handleLogout,
	isSmall,
}: {
	handleLogout: any
	isSmall: boolean
}) {
	const classes = useStyles()
	return (
		<Grid item xs={5} md={4} className={classes.menuIcons}>
			{/* <OfflineButton /> */}
			<LanguageButton />
			<HelpButton />
			<SettingsButton handleLogout={handleLogout} isSmall={isSmall} />
		</Grid>
	)
}

export default GridNavbarActions
